/**
 * This file was automatically generated by toolspec-generator.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSON file,
 * and run toolspec-generator to regenerate this file.
 */
import { Tool } from '@aws-sdk/client-bedrock-runtime'

export const SandboxSchema: Tool[] = [
  {
    toolSpec: {
      name: 'run_script',
      description:
        "Run a shell command inside this job's sandbox VM, working directory /workspace. Use it to execute scripts you authored with write_file (e.g. `python inventory.py`), unzip the corpus, or inspect the filesystem (`ls -R data`). The job's uploaded documents are already hydrated under /workspace. The document toolchain is preinstalled (Python 3.12 with pandas, openpyxl, xlrd, pdfplumber, PyMuPDF, pdf2image, rapidocr_onnxruntime, python-docx, python-pptx, striprtf, pillow, cv2, chardet, lxml, python-magic; CLI tools pdftoppm, antiword, rg, file) — never pip-install these. For anything else install offline first (`pip install <pkg> --find-links /opt/sandbox/wheels --no-index`) and use the network only if that fails. Returns { stdout, stderr, exit_code, timed_out }. stdout/stderr are clamped to a head+tail slice — never echo a whole corpus or a big result to stdout; have your script write results to a file, then locate what you need with search_files and read it back in windows with read_file.",
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          required: ['command'],
          properties: {
            command: {
              type: 'string',
              description:
                'Shell command to run in /workspace (e.g. "python parse.py", "unzip -o corpus.zip -d data", "pip install pyxlsb --find-links /opt/sandbox/wheels --no-index").'
            },
            timeout_seconds: {
              type: 'integer',
              minimum: 1,
              description:
                'Optional wall-clock cap for this command. Omit for the sandbox default. Raise it for long parses or installs.'
            }
          }
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'write_file',
      description:
        'Write a UTF-8 text file into the sandbox VM filesystem, relative to /workspace. Use it to author parsing scripts and small config/data files. Creates parent directories and overwrites an existing file at the same path. Returns { ok, bytes, path }. This writes to the VM only — it does NOT touch the graph; entities reach the graph when your scripts POST to the graph-write gateway.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          required: ['path', 'content'],
          properties: {
            path: {
              type: 'string',
              description:
                'Path relative to /workspace (e.g. "parse_equipment.py", "scratch/notes.txt"). Leading slashes and .. traversal are rejected.'
            },
            content: {
              type: 'string',
              description:
                'Full UTF-8 file contents. The previous contents at this path, if any, are replaced.'
            }
          }
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'read_file',
      description:
        'Read a window of a UTF-8 text file from the sandbox VM filesystem, relative to /workspace. Use it to read back slices your scripts wrote (an inventory summary, a sample, a parse report) or the region of a text document that search_files located. Reads are WINDOWED: by default the first ~1000 lines (hard byte cap per read); page through longer files with offset/limit. Returns { content, path, truncated, total_lines, total_bytes } so you always know how much you have not seen. Binary files (PDFs, images, spreadsheets) are never returned as text — you get { binary: true, total_bytes } back; extract those with a script instead. Never page an entire large file into context; read the windows you need.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          required: ['path'],
          properties: {
            path: {
              type: 'string',
              description:
                'Path relative to /workspace (e.g. "inventory.json", "data/manifest.csv").'
            },
            offset: {
              type: 'integer',
              minimum: 1,
              description:
                '1-based line number to start reading from. Omit to read from the top. Use with limit to page through a long file.'
            },
            limit: {
              type: 'integer',
              minimum: 1,
              description:
                'Maximum number of lines to return. Omit for the default window (~1000 lines).'
            }
          }
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'view_page_image',
      description:
        'Look at a page with your own eyes: rasterize one page of a PDF (or an image file) from the sandbox VM and receive it as an actual image. Supports ONLY PDFs and image files (png/jpg/tiff/bmp/gif/webp). Do NOT call this on doc/docx/pptx/rtf/spreadsheets/CAD — use `helpers extract` first, then read its native artifacts. Use it when document text extraction loses the content — drawings, P&IDs, single-line diagrams, nameplate photos, stamps, and scanned tables that OCR mangles. One page per call. An image costs far more context than its text, so extract first (read_file, `helpers extract`) and look only when document text loses the content.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          required: ['path'],
          properties: {
            path: {
              type: 'string',
              description:
                'PDF or image file only, relative to /workspace (e.g. "docs/drawings/p-id-042.pdf"). For doc/docx/pptx/rtf, spreadsheets, or CAD, use `helpers extract`.'
            },
            page: {
              type: 'integer',
              minimum: 1,
              description: '1-based page number for PDFs (default 1). Ignored for image files.'
            },
            dpi: {
              type: 'integer',
              minimum: 72,
              maximum: 300,
              description:
                'Render DPI for PDF pages (default 150). Raise it for small text on dense drawings.'
            }
          }
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'search_files',
      description:
        'Search file CONTENTS under /workspace with a regular expression and get back match locations — { matches: [{ file, line, text }], truncated }. This is how you find where something lives before reading it: search first, then read_file the window around the hit (offset/limit). Searches text files only (binaries are skipped). Results are capped; narrow the pattern or path instead of paging huge result sets.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          required: ['pattern'],
          properties: {
            pattern: {
              type: 'string',
              description:
                'Regular expression to search for (e.g. "functional location", "9558-22A-\\\\d+", "(?i)line\\\\s*12").'
            },
            path: {
              type: 'string',
              description:
                'Optional file or directory relative to /workspace to scope the search (e.g. "docs", "out/inventory.json"). Omit to search the whole workspace.'
            },
            max_results: {
              type: 'integer',
              minimum: 1,
              maximum: 250,
              description: 'Maximum matches to return (default 100).'
            }
          }
        }
      }
    }
  }
]

export enum SandboxToolNames {
  RunScript = 'run_script',
  WriteFile = 'write_file',
  ReadFile = 'read_file',
  ViewPageImage = 'view_page_image',
  SearchFiles = 'search_files'
}
